// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"87b6332d","608":"2ac60421","643":"1d4daafd"}[chunkId] + ".chunk.js";
};